"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndeterminateCheckbox = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var reactstrap_1 = require("reactstrap");
var IndeterminateCheckbox = function (_a) {
    var indeterminate = _a.indeterminate, props = __rest(_a, ["indeterminate"]);
    var ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if ((ref === null || ref === void 0 ? void 0 : ref.current) && typeof indeterminate === 'boolean') {
            ref.current.indeterminate = !props.checked && indeterminate;
        }
    }, [ref, props.checked, indeterminate]);
    return (0, jsx_runtime_1.jsx)(reactstrap_1.Input, __assign({ type: "checkbox", innerRef: ref }, props));
};
exports.IndeterminateCheckbox = IndeterminateCheckbox;
